import { Component, OnInit, Input } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-auth-signup-form',
  templateUrl: './auth-signup-form.component.html',
  styleUrls: ['./auth-signup-form.component.sass']
})
export class AuthSignupFormComponent implements OnInit {
  @Input() model: any = {};

  public form: NgForm;

  ngOnInit() {
  }

  onSubmit(form: NgForm) {
    this.form = form;
  }
}
